import {jsonArrayMember, jsonMember, jsonObject} from "typedjson";
import {PitActivityStateProgramIndicatorValues} from "./pit-activity-state-program-indicator-values";

/** Показатели государственных программ */
@jsonObject
export class PitActivityStateProgramIndicators {

  /** Показатель и его свойства, необходимые для отображения на экране */
  @jsonMember({name: "indicatorId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _indicatorId: number;

  /** Плнановые и фактические значения показателя */
  @jsonArrayMember(PitActivityStateProgramIndicatorValues, {name: "indicatorValues", emitDefaultValue: false, isRequired: false})
  private _indicatorValues: PitActivityStateProgramIndicatorValues[];

  get indicatorId(): number {
    return this._indicatorId;
  }

  set indicatorId(value: number) {
    this._indicatorId = value;
  }

  get indicatorValues(): PitActivityStateProgramIndicatorValues[] {
    return this._indicatorValues;
  }

  set indicatorValues(value: PitActivityStateProgramIndicatorValues[]) {
    this._indicatorValues = value;
  }
}
